import { useTolgee } from "@tolgee/react";
import countries from "i18n-iso-countries";
import de from "i18n-iso-countries/langs/de.json";
import en from "i18n-iso-countries/langs/en.json";
import fr from "i18n-iso-countries/langs/fr.json";
import nl from "i18n-iso-countries/langs/nl.json";
import pl from "i18n-iso-countries/langs/pl.json";
import ru from "i18n-iso-countries/langs/ru.json";

countries.registerLocale(en);
countries.registerLocale(de);
countries.registerLocale(fr);
countries.registerLocale(nl);
countries.registerLocale(pl);
countries.registerLocale(ru);

export function useCountries() {
  const language = useTolgee(["language"]).getLanguage() ?? "de";

  return Object.entries(
    countries.getNames(language.slice(0, 2), { select: "official" })
  )
    .map(([code, name]) => ({ code, name }))
    .sort((a, b) => a.name.localeCompare(b.name));
}
